import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { z } from 'zod';

import { CallOffsCalendar } from '~/modules/callOff';

import { i18n } from '~/utils';
import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';
import { getRouteHead } from '~/utils/routeUtils';

import { routeParams } from '../-routeParams';

const title = i18n.t(($) => $.calendar.pageTitle, { ns: 'callOff' });
const description = i18n.t(($) => $.calendar.pageDescription, {
  ns: 'callOff',
});

const zodCallOffsCalendarSearchSchema = z.object({
  startDate: z.iso.date().optional().catch(undefined),
});

export const Route = createFileRoute('/(main)/demand/call-offs/calendar/')({
  beforeLoad: createProtectedRoute({
    routePath: '/demand/call-offs/calendar/',
    ...routeParams,
  }),
  component: CallOffsCalendar,
  head: () => getRouteHead(title, description),
  search: {
    middlewares: [stripSearchParams({ startDate: undefined })],
  },
  staticData: {
    AppBar: {
      title,
    },
  },
  validateSearch: zodCallOffsCalendarSearchSchema,
});

export const DEMAND_CALLOFFS_CALENDAR = buildRouteExport({
  Route,
  ...routeParams,
});
